import React, { useEffect, useState } from "react";
import { Table, Image, Tag, Modal, Select, notification, Input } from "antd";
import { Dropdown } from "rsuite";
import PlansModal from "../components/TrainerPlans";
import Addtrainer from "../components/addtrainer";
import styled from "styled-components";
import TrainerDelete from "../components/TranierDelete";
import Loader from "../atoms/Loader";
import PayDate from "./PayDate";
import {Flex} from "@mantine/core";
import SalaryAndMinutes from "./SalaryAndMinutes";
import { IconCalendarCheck, IconClock12, IconTrash, IconEdit, IconBuildingCommunity, IconUserEdit } from '@tabler/icons-react';
import TutorSchoolRestrictions from './TutorSchoolRestrictions';
import TutorProfileEdit from './TutorProfileEdit';

const TrainerHead = styled.div`
  display: flex;
  height: 70px;
  justify-content: space-between;
  padding: 5px 20px;
`;

const StyledLoad = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
`;

const Dropdowned = styled(Dropdown)`
  .rs-dropdown-item {
    display: flex;
    align-items: center;
    gap: 6px;
  }
`;

const SearchRow = styled.div`
  display: flex;
  gap: 10px;
  margin: 0 20px 16px;
  flex-wrap: wrap;
`;

const axios = require("axios").default;

const CHILD_AGE_OPTIONS = [
  { value: '4_8', label: 'Ages 4–8' },
  { value: '9_12', label: 'Ages 9–12' },
  { value: '13_17', label: 'Ages 13–17' },
];

const Trainers = () => {
  const [trainers, setTrainers] = useState([]);
  const [plan, setPlan] = useState(false);
  const [salaryList, setSalaryList] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [trainerList, setTrainerList] = useState({});
  const [isOpened, setIsOpened] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payDateList, setPayDateList] = useState({});

  // Search
  const [searchFirstName, setSearchFirstName] = useState('');
  const [searchLastName, setSearchLastName] = useState('');
  const [searchEmail, setSearchEmail] = useState('');
  const [searchStatus, setSearchStatus] = useState(null);
  const [searchType, setSearchType] = useState(null);

  // Tutor education types (API: trainer/education-types)
  const [educationTypeOptions, setEducationTypeOptions] = useState([]);

  // Edit modal
  const [editModal, setEditModal] = useState(false);
  const [editTrainer, setEditTrainer] = useState(null);
  const [editType, setEditType] = useState(null);
  const [editStatus, setEditStatus] = useState(null);
  const [editEducationTypeIds, setEditEducationTypeIds] = useState([]);
  /** '4_8' | '9_12' | '13_17' — only when student type is Adults & kids */
  const [editChildAgeBands, setEditChildAgeBands] = useState([]);
  const [editLoading, setEditLoading] = useState(false);

  // School restrictions modal
  const [restrictionsModal, setRestrictionsModal] = useState(false);
  const [restrictionsTrainer, setRestrictionsTrainer] = useState(null);

  // Profile edit modal
  const [profileModal, setProfileModal] = useState(false);
  const [profileTrainer, setProfileTrainer] = useState(null);

  const showPlanModal = (detail) => setPlan(detail);
  const showSalary = (detail) => { setSalaryList(detail); setModalVisible(true); };
  const showPlanDelete = (record) => { setTrainerList(record); setIsOpened(true); };

  const openRestrictionsModal = (record) => {
    setRestrictionsTrainer(record);
    setRestrictionsModal(true);
  };

  const openProfileModal = (record) => {
    setProfileTrainer(record);
    setProfileModal(true);
  };

  const openEditModal = (record) => {
    setEditTrainer(record);
    const tt = record.trainer_type;
    setEditType(tt === 1 ? 1 : tt ? 2 : null);
    setEditStatus(record.status === 'Active' ? 1 : 3);
    const et = record.education_type_ids;
    setEditEducationTypeIds(Array.isArray(et) ? [...et] : []);
    const bands = [];
    if (record.trainer_child_age_4_8) bands.push('4_8');
    if (record.trainer_child_age_9_12) bands.push('9_12');
    if (record.trainer_child_age_13_17) bands.push('13_17');
    setEditChildAgeBands(bands);
    setEditModal(true);
  };

  const handleEditSave = async () => {
    setEditLoading(true);
    try {
      const body = {
        trainer_type: editType,
        status: editStatus,
        education_type_ids: editEducationTypeIds || [],
      };
      if (editType === 2) {
        body.trainer_child_age_4_8 = editChildAgeBands.includes('4_8');
        body.trainer_child_age_9_12 = editChildAgeBands.includes('9_12');
        body.trainer_child_age_13_17 = editChildAgeBands.includes('13_17');
      } else {
        body.trainer_child_age_4_8 = false;
        body.trainer_child_age_9_12 = false;
        body.trainer_child_age_13_17 = false;
      }
      await axios.post(`trainer/update/${editTrainer.id}`, body);
      notification.success({ message: 'Tutor updated' });
      setEditModal(false);
      getTrainerList();
    } catch (err) {
      const msg = err?.response?.data?.message || 'Something went wrong';
      notification.error({ message: msg });
    } finally {
      setEditLoading(false);
    }
  };

  const filteredTrainers = trainers.filter((t) => {
    const qFirst = searchFirstName.toLowerCase();
    const qLast = searchLastName.toLowerCase();
    const qEmail = searchEmail.toLowerCase();
    return (
      (!qFirst || t.first_name?.toLowerCase().includes(qFirst)) &&
      (!qLast || t.last_name?.toLowerCase().includes(qLast)) &&
      (!qEmail || t.email?.toLowerCase().includes(qEmail)) &&
      (!searchStatus || (searchStatus === 'Pasive' ? (t.status === 'Pasive' || t.status === 'Pasif') : t.status === searchStatus)) &&
      (!searchType || t.trainer_type === searchType)
    );
  });

  const columns = [
    {
      title: "",
      dataIndex: "image",
      key: "image",
      render: (_, record) => (
        <Image width={60} src={record.image_url + "/" + record.image} />
      ),
    },
    { title: "Name", dataIndex: "first_name", key: "first_name" },
    { title: "Last Name", dataIndex: "last_name", key: "last_name" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Country", dataIndex: "country", key: "country" },
    { title: "Status", dataIndex: "status", key: "status" },
    {
      title: "Student type",
      dataIndex: "trainer_type",
      key: "trainer_type",
      render: (_, record) => {
        if (record.trainer_type === 2) return <Tag color="green">Adults & kids</Tag>;
        if (record.trainer_type === 1) return <Tag color="blue">Adults only</Tag>;
        return <Tag>-</Tag>;
      },
    },
    {
      title: "Child ages",
      key: "child_ages",
      width: 160,
      render: (_, record) => {
        if (record.trainer_type !== 2) return <span style={{ color: '#999' }}>—</span>;
        const parts = [];
        if (record.trainer_child_age_4_8) parts.push('4–8');
        if (record.trainer_child_age_9_12) parts.push('9–12');
        if (record.trainer_child_age_13_17) parts.push('13–17');
        if (!parts.length) return <span style={{ color: '#999' }}>—</span>;
        return (
          <span style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {parts.map((p) => (
              <Tag key={p}>{p}</Tag>
            ))}
          </span>
        );
      },
    },
    {
      title: "Tutor programs",
      key: "education_types",
      width: 220,
      render: (_, record) => {
        const ids = record.education_type_ids || [];
        if (!ids.length) return <span style={{ color: '#999' }}>—</span>;
        return (
          <span style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {ids.map((id) => {
              const opt = educationTypeOptions.find((o) => o.value === id);
              return <Tag key={id}>{opt ? opt.label : id}</Tag>;
            })}
          </span>
        );
      },
    },
    {
      title: "",
      key: "actions",
      render: (_, record) => (
        <Dropdowned title="Functions">
          <Dropdown.Item
            onClick={() => openEditModal(record)}
            icon={<IconEdit stroke={2} size={"16px"} />}
          >
            Edit
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => openProfileModal(record)}
            icon={<IconUserEdit stroke={2} size={"16px"} />}
          >
            Profil Düzenle
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => openRestrictionsModal(record)}
            icon={<IconBuildingCommunity stroke={2} size={"16px"} />}
          >
            Okul Kısıtlamaları
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => showPlanModal(record)}
            icon={<IconCalendarCheck stroke={2} size={"16px"} />}
          >
            Plans
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => showSalary(record)}
            icon={<IconClock12 stroke={2} size={"16px"} />}
          >
            Salary and Minutes
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => showPlanDelete(record)}
            icon={<IconTrash stroke={2} size={"16px"} />}
          >
            Delete
          </Dropdown.Item>
        </Dropdowned>
      ),
    },
  ];

  const getTrainerList = async () => {
    setLoading(true);
    try {
      const response = await axios.get('trainer/list');
      setTrainers(response.data.list);
    } catch (error) {
      console.error('Error fetching trainer list:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadEducationTypes = async () => {
    try {
      const res = await axios.get('trainer/education-types');
      if (res.data?.list?.length) {
        setEducationTypeOptions(
          res.data.list.map((t) => ({ value: t.id, label: t.name }))
        );
      }
    } catch (e) {
      console.error('Error fetching education types:', e);
    }
  };

  useEffect(() => {
    getTrainerList();
    loadEducationTypes();
  }, []);

  return (
    <>
      <TrainerHead>
        <h1 className="h3 mt-3"><strong>TRAINER</strong> LIST </h1>
        <Flex justify={"flex-end"} gap={"20px"}>
          <PayDate setPayDateList={setPayDateList} getTrainerList={getTrainerList} />
          <Addtrainer getTrainerList={getTrainerList} />
        </Flex>
      </TrainerHead>

      <SearchRow>
        <Input
          placeholder="First name"
          allowClear
          value={searchFirstName}
          onChange={(e) => setSearchFirstName(e.target.value)}
          style={{ flex: 1, minWidth: 120 }}
        />
        <Input
          placeholder="Last name"
          allowClear
          value={searchLastName}
          onChange={(e) => setSearchLastName(e.target.value)}
          style={{ flex: 1, minWidth: 120 }}
        />
        <Input
          placeholder="Email"
          allowClear
          value={searchEmail}
          onChange={(e) => setSearchEmail(e.target.value)}
          style={{ flex: 2, minWidth: 160 }}
        />
        <Select
          allowClear
          placeholder="Status"
          value={searchStatus}
          onChange={(val) => setSearchStatus(val ?? null)}
          style={{ flex: 1, minWidth: 130 }}
          options={[
            { value: 'Active', label: 'Active' },
            { value: 'Pasive', label: 'Pasive' },
          ]}
        />
        <Select
          allowClear
          placeholder="Student type"
          value={searchType}
          onChange={(val) => setSearchType(val ?? null)}
          style={{ flex: 1, minWidth: 160 }}
          options={[
            { value: 1, label: 'Adults only' },
            { value: 2, label: 'Adults & kids' },
          ]}
        />
      </SearchRow>

      <p>
        {loading ? (
          <StyledLoad><Loader size={"md"} /></StyledLoad>
        ) : (
          <Table columns={columns} dataSource={filteredTrainers} />
        )}
      </p>

      {plan ? <PlansModal plan={plan} visiblePlanCallback={showPlanModal} /> : null}

      {salaryList ? (
        <SalaryAndMinutes
          salaryList={salaryList}
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          getTrainerList={getTrainerList}
          payDateList={payDateList}
        />
      ) : null}

      {trainerList ? (
        <TrainerDelete
          trainerList={trainerList}
          setIsOpened={setIsOpened}
          isOpened={isOpened}
          getTrainerList={getTrainerList}
        />
      ) : null}

      <TutorSchoolRestrictions
        trainer={restrictionsTrainer}
        open={restrictionsModal}
        onClose={() => {
          setRestrictionsModal(false);
          setRestrictionsTrainer(null);
        }}
      />

      <TutorProfileEdit
        trainer={profileTrainer}
        open={profileModal}
        onClose={() => {
          setProfileModal(false);
          setProfileTrainer(null);
        }}
        onSaved={getTrainerList}
      />

      {/* Edit Modal */}
      <Modal
        title={editTrainer ? `${editTrainer.first_name} ${editTrainer.last_name} — Edit` : 'Edit'}
        open={editModal}
        onOk={handleEditSave}
        onCancel={() => setEditModal(false)}
        confirmLoading={editLoading}
        okText="Save"
        cancelText="Cancel"
        width={480}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Tutor education type</label>
            <Select
              mode="multiple"
              allowClear
              placeholder="Select tutor education type(s)"
              style={{ width: '100%' }}
              value={editEducationTypeIds}
              onChange={(vals) => setEditEducationTypeIds(vals || [])}
              options={educationTypeOptions}
              optionFilterProp="label"
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Student type</label>
            <Select
              style={{ width: '100%' }}
              value={editType}
              onChange={(val) => {
                setEditType(val);
                if (val !== 2) setEditChildAgeBands([]);
              }}
              options={[
                { value: 1, label: 'Adults only' },
                { value: 2, label: 'Adults & kids' },
              ]}
            />
          </div>
          {editType === 2 ? (
            <div>
              <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>
                Child age groups served
              </label>
              <Select
                mode="multiple"
                allowClear
                placeholder="Select age range(s)"
                style={{ width: '100%' }}
                value={editChildAgeBands}
                onChange={(vals) => setEditChildAgeBands(vals || [])}
                options={CHILD_AGE_OPTIONS}
                optionFilterProp="label"
              />
              <small style={{ color: '#888', display: 'block', marginTop: 6 }}>
                For tutors who teach children: choose 4–8, 9–12, 13–17.
              </small>
            </div>
          ) : null}
          <div>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Status</label>
            <Select
              style={{ width: '100%' }}
              value={editStatus}
              onChange={(val) => setEditStatus(val)}
              options={[
                { value: 1, label: 'Active' },
                { value: 3, label: 'Inactive' },
              ]}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Trainers;
